export type GenreType = 'it' | 'technical' | 'sports' 
    | 'legal' | 'life_sciences' | 'marketing' | 'other'

export interface Genre {
    id: GenreType
    genre: string
}

export const GENRES: Genre[] = [
    {id: 'it', genre: 'IT'},
    {id: 'technical', genre: 'Technical'},
    {id: 'sports', genre: 'Sports & Entertaiment'},
    {id: 'legal', genre: 'Legal'},
    {id: 'life_sciences', genre: 'Life Sciences'},
    {id: 'marketing', genre: 'Marketing'},
    {id: 'other', genre: 'Other'}
]

export type StageType = 'FILE_PREPARATION' | 'FILE_PARSING' 
| 'OCR' | 'ANONYMIZATION' | 'DOCUMENT_PARSING' 
| 'TABLE_PARSING' | 'REDACTION' | 'RECYCLING' | 'RECYCLING_ONLY' | 'IMMEDIATE_TRANSLATION'
| 'ENHANCEMENT' | 'TRUST_MINING' 
| 'CORRECTION' | 'FINAL_REDACTION'

enum StageTypeOrdered {
    FILE_PREPARATION,
    FILE_PARSING,
    TABLE_PARSING,
    ANONYMIZATION,
    REDACTION,
    RECYCLING,
    RECYCLING_ONLY,
    IMMEDIATE_TRANSLATION,
    ENHANCEMENT,
    TRUST_MINING,
    FINAL_REDACTION,
    CORRECTION,
  }
  
  const stageTypeOrder = Object.values(StageTypeOrdered)

  export const stageSort = (s1: StageType, s2: StageType) => stageTypeOrder.indexOf(s1) - stageTypeOrder.indexOf(s2)

const STAGES_FORBIDDING_SAME_SOURCE_AND_TARGET: StageType[] = [
    "IMMEDIATE_TRANSLATION",
    "RECYCLING",
    "RECYCLING_ONLY"
]

const TECHNICAL_TABLET_STAGES: StageType[] = [
    "FILE_PREPARATION",
    "FILE_PARSING",
    "OCR",
    "DOCUMENT_PARSING",
    "TABLE_PARSING"
]

export const tabletAllowsSameSourceAndTarget = (stages: { stage: StageType }[]) =>
    !stages.some((s) => STAGES_FORBIDDING_SAME_SOURCE_AND_TARGET.includes(s.stage))

/** Final redaction only (no IT / recycling) — job is monolingual copy-edit. */
export const tabletRequiresSameSourceAndTarget = (stages: { stage: StageType }[]) => {
    const workStages = stages.filter((s) => !TECHNICAL_TABLET_STAGES.includes(s.stage))
    return workStages.length === 1 && workStages[0].stage === "FINAL_REDACTION"
}